import { render } from "./SixDimensionAnalysis.vue?vue&type=template&id=498720f7&scoped=true"
import script from "./SixDimensionAnalysis.vue?vue&type=script&lang=js"
export * from "./SixDimensionAnalysis.vue?vue&type=script&lang=js"

import "./SixDimensionAnalysis.vue?vue&type=style&index=0&id=498720f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498720f7"]])

export default __exports__